import { createContext } from 'react'
export const GlobalContext = createContext()

export const ModalContext = createContext()

export const AuthContext = createContext()

export const LanguageContext = createContext()